import { Helmet } from 'react-helmet';

import ShowroomPage from './pages/showroom.page';
const App: React.FC = () => {
  return (
    <div className={`full-app-container`}>
      <Helmet>
        <title>AVATR Car Studio</title>
        <meta name="description" content="Showroom virtual 3D de AVATR" />
      </Helmet>
      <ShowroomPage/>
    </div>
  );
};

export default App;
